import * as rd from '@devexperts/remote-data-ts'
import { createSelector } from '@reduxjs/toolkit'
import { mapReservationModelsToQuoteReservations } from '@/utils/mapReservationModelsToQuoteReservations'
import { cartSlice } from '..'

export const cartDetailReservationsSelector = createSelector(
  [cartSlice.selectors.cartDetail],
  (cartDetail) => {
    if (!rd.isSuccess(cartDetail)) {
      return []
    }

    return mapReservationModelsToQuoteReservations(
      cartDetail.value.cart.reservationModels
    )
  }
)
